// apps/web/src/components/brand/integration-glyph.tsx

import { BrandGlyph } from "@/components/brand/brand-glyph";
import { asBrandGlyphKey } from "@/lib/brand-keys";
import { integrationIdentityForSource } from "@/lib/integration-brands";
import type { BrandGlyphProps } from "@/components/brand/brand-glyph";

export function IntegrationGlyph({
  provider,
  integration,
  label,
  brand,
  size = "sm",
  className,
  decorative = true,
}: {
  provider: string;
  integration: string;
  label?: string | null;
  /**
   * LAT-1996 — a brand key the CALLER already knows, typically stamped by the
   * server. When given it wins outright: a caller that was told which mark to
   * render must not have that answer second-guessed by a client-side table.
   */
  brand?: string;
  size?: BrandGlyphProps["size"];
  className?: string;
  decorative?: boolean;
}) {
  const identity = integrationIdentityForSource({
    provider,
    integration,
    label,
  });
  const glyph = (
    <BrandGlyph
      brand={brand === undefined ? identity.brand : asBrandGlyphKey(brand)}
      label={identity.label}
      size={size}
      className={className}
    />
  );
  return decorative ? (
    <span aria-hidden="true" className="inline-flex items-center leading-none">
      {glyph}
    </span>
  ) : (
    glyph
  );
}
